module.exports = __webpack_public_path__ + "img/67800.c40449a5.jpg";